/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { KeyValue } from "./key_value";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiVariablesPb {
  utime: number;
  lastTransitionUtime: number;
  vars: KeyValue[];
  boostCommanded: boolean;
}

function createBaseUiVariablesPb(): UiVariablesPb {
  return { utime: 0, lastTransitionUtime: 0, vars: [], boostCommanded: false };
}

export const UiVariablesPb = {
  encode(message: UiVariablesPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.lastTransitionUtime !== 0) {
      writer.uint32(16).sint64(message.lastTransitionUtime);
    }
    for (const v of message.vars) {
      KeyValue.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.boostCommanded === true) {
      writer.uint32(32).bool(message.boostCommanded);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiVariablesPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiVariablesPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.lastTransitionUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.vars.push(KeyValue.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.boostCommanded = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiVariablesPb {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      lastTransitionUtime: isSet(object.lastTransitionUtime) ? globalThis.Number(object.lastTransitionUtime) : 0,
      vars: globalThis.Array.isArray(object?.vars) ? object.vars.map((e: any) => KeyValue.fromJSON(e)) : [],
      boostCommanded: isSet(object.boostCommanded) ? globalThis.Boolean(object.boostCommanded) : false,
    };
  },

  toJSON(message: UiVariablesPb): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.lastTransitionUtime !== 0) {
      obj.lastTransitionUtime = Math.round(message.lastTransitionUtime);
    }
    if (message.vars?.length) {
      obj.vars = message.vars.map((e) => KeyValue.toJSON(e));
    }
    if (message.boostCommanded === true) {
      obj.boostCommanded = message.boostCommanded;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiVariablesPb>, I>>(base?: I): UiVariablesPb {
    return UiVariablesPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiVariablesPb>, I>>(object: I): UiVariablesPb {
    const message = createBaseUiVariablesPb();
    message.utime = object.utime ?? 0;
    message.lastTransitionUtime = object.lastTransitionUtime ?? 0;
    message.vars = object.vars?.map((e) => KeyValue.fromPartial(e)) || [];
    message.boostCommanded = object.boostCommanded ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
